import { request } from '@api/service';
import { api3 } from '@api/env';
export function getStatisticalData(params) {
  return request({
    baseURL: api3,
    url: '/api/Tasks/statistics',
    method: 'get',
    withCredentials: false,
    params: params
  });
}
export function getTaskStaticalData(params) {
  return request({
    baseURL: api3,
    url: '/api/Tasks/statFullfledged',
    method: 'get',
    withCredentials: false,
    params: params
  });
}
export function getExtendedStats(params) {
  return request({
    baseURL: api3,
    url: '/api/Tasks/extendedStats',
    method: 'get',
    withCredentials: false,
    params: params
  });
}
export function getStaffPerformance(params) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/staffPerformance',
    method: 'get',
    withCredentials: false,
    params: params
  });
}
export function getUnclaimedConfirmation(params) {
  return request({
    baseURL: api3,
    url: '/api/confirmations/UnclaimedConfirmation',
    method: 'get',
    withCredentials: false,
    params: params
  });
}